export default __webpack_public_path__ + "static/media/leftArrow.1f1b8624.svg";